import { BaseWebComponentTranslator } from '../../../framework/BaseWebComponentTranslator';

export function getTranslatedCompanyStatus(isSuspended: boolean): string {
  const translator = BaseWebComponentTranslator.getInstance();
  return isSuspended ? translator.translateFn('Suspended') : translator.translateFn('Active');
}
